import React, { useState } from "react";
import {
    Box,
    TextField,
    MenuItem,
    Button,
    Typography
} from "@mui/material";

import useMicroTipApi from "../../../api/MicroTipApi";
import ScienceIcon from "@mui/icons-material/Science";
import ConfirmDialog from "../../Common/ConfirmDialog";

export default function ({ onCalibrate, setResultDataMap, rows, parameters }) {
    const [model, setModel] = useState("0");
    const [description, setDescription] = useState("");
    console.log("HEADER ROWS:", rows);
    console.log("Parameter ROWS:", parameters);
    const { callApi, loading, error } = useMicroTipApi(parameters, rows);
    const [openValidationDialog, setOpenValidationDialog] = useState(false);
    const [validationMessage, setValidationMessage] = useState("");
    // Transform API → History Grid
    const transformApiToHistory = (data) => {
        if (!data) return null;

        const safe = (v) =>
            v === null || v === undefined || isNaN(v)
                ? 0
                : Number(v);

        const format6 = (v) =>
            safe(v).toFixed(6);

        return {
            B0: format6(data.fB0),
            B1: format6(data.fB1),
            B2: format6(data.fB2),
            B3: format6(data.fB3),
            B4: format6(data.fB4),
            R2: format6(data.fGoodnessOfFit),
        };
    };
    const validateCalibrationRows = (rows) => {
        if (!rows || rows.length === 0) return false;

        return rows.every(
            (r) =>
                r.conc !== "" &&
                r.conc !== null &&
                r.conc !== undefined &&
                r.resp !== "" &&
                r.resp !== null &&
                r.resp !== undefined
        );
    };
   
    // Button Click → Call API
    const handleSubmit = async () => {
        console.log("PARAMETERS:", parameters);
        console.log("ROWS:", rows);

        const isValid = validateCalibrationRows(rows);

        if (!isValid) {
            setValidationMessage(
                "Please fill all Concentration and Response values before calibration."
            );
            setOpenValidationDialog(true);
            return;
        }

        if (onCalibrate) {
            onCalibrate(); // expands Results panel
        }
        try {
            const apiData = await callApi();


            console.log("API RESPONSE:", apiData);

            const formatted = transformApiToHistory(apiData);

            if (!formatted) return;

            setResultDataMap(prev => {
                const prevData = prev || {};
                const nextRun = Object.keys(prevData).length + 1;

                const finalDescription =
                    description && description.trim() !== ""
                        ? description
                        : `Run ${nextRun}`;
                const newEntry = {
                    run: nextRun,
                    description: finalDescription,
                    result: formatted,
                    rows: rows,
                    parameters: parameters
                };

                const updated = {
                    ...prevData,
                    [nextRun]: newEntry
                };

                // Persist in session
                sessionStorage.setItem("calibrationHistory", JSON.stringify(updated));

                return updated;
            });
            if (onCalibrate) onCalibrate();

        } catch (err) {
            console.error("API ERROR:", err);
        }
    };
    return (
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", md: "row" }, 
                justifyContent: "flex-start",
                backgroundColor: "#fff",                
            }}
        >
            {/* LEFT SECTION */}
            <Box
                sx={{
                    width: { xs: "100%", md: "80%" },
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    gap: 2, 
                    p: 2,
                    borderRadius: 3,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    alignItems: { xs: "stretch", sm: "center" },
                }}
            >
                {/* Dropdown */}
                <TextField
                    select
                    label="Math Model"
                    value={model}
                    onChange={(e) => setModel(e.target.value)}
                    sx={{
                        flex: 1,
                        minWidth: 140,
                    }}
                    size="medium"
                >
                    <MenuItem value="0">Linear</MenuItem>
                    <MenuItem value="1">Logit4</MenuItem>
                    <MenuItem value="2">Logit5</MenuItem>
                    <MenuItem value="3">Cubic Spline</MenuItem>
                    <MenuItem value="4">K-Model</MenuItem>
                </TextField>

                {/* Description */}
                <TextField
                    label="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    sx={{
                        flex: 3,
                        minWidth: 200,
                    }}
                    size="medium"
                />

                {/* Button */}
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    startIcon={<ScienceIcon />}
                    disabled={loading}
                    sx={{
                        whiteSpace: "nowrap",
                        minWidth: 140,
                        minHeight: 56,
                        px: 3,
                        alignSelf: { xs: "stretch", sm: "auto" },
                    }}
                >
                    {loading ? "Calibrate..." : "Calibrate"}
                </Button>

                {/* Error */}
                {error && (
                    <Typography
                        color="error"
                        sx={{
                            width: "100%",
                            mt: { xs: 1, sm: 0 },
                        }}
                    >
                        {error}
                    </Typography>
                )}
            </Box>

            {/* RIGHT SPACER (hidden on mobile) */}
            <Box
                sx={{
                    width: { xs: "0%", md: "20%" },
                    display: { xs: "none", md: "block" },
                }}
            />

            {/* Dialog */}
            <ConfirmDialog
                open={openValidationDialog}
                title="Validation Error"
                message={validationMessage}
                onConfirm={() => setOpenValidationDialog(false)}
                onCancel={() => setOpenValidationDialog(false)}
            />
        </Box>

        
    );
}